import { InputHTMLAttributes, KeyboardEvent, forwardRef } from 'react'

import cn from 'classnames'

import ImageComponent from 'components/image'

import { STRING_PREVENT_INPUT_AUTO_FILL } from 'constants/constants'

import css from './search.module.scss'

export type Suggestion = {
  name: string
  icon?: string
}

export type InputProps = {
  name: string
  onPress: (event: KeyboardEvent<HTMLInputElement>) => void
  isDisabled?: boolean
  placeholder?: string
  errorMessage?: string
  className?: string
  wrapperClassName?: string
  icon?: JSX.Element
  onBlur?: (changeEvent: React.FocusEvent<HTMLInputElement>) => void
  suggestions?: Suggestion[]
  suggestionHandler?: (suggestion: Suggestion) => void
  selectedSuggestionIndex?: number
  autoComplete?: string
} & InputHTMLAttributes<HTMLInputElement>

const Search = forwardRef<HTMLInputElement, InputProps>(
  (
    {
      name,
      onPress,
      isDisabled,
      placeholder,
      onBlur,
      className,
      wrapperClassName,
      icon,
      suggestions,
      suggestionHandler,
      selectedSuggestionIndex,
      autoComplete = STRING_PREVENT_INPUT_AUTO_FILL,
      ...rest
    },
    ref
  ) => (
    <div className={cn([css.container, wrapperClassName])}>
      {!!icon && <div className={css.icon}>{icon}</div>}
      <input
        className={cn(css.input, className)}
        onKeyDown={onPress}
        onBlur={onBlur}
        name={name}
        placeholder={placeholder}
        disabled={isDisabled}
        ref={ref}
        enterKeyHint="done"
        autoComplete={autoComplete}
        {...rest}
      />
      {!!suggestions && (
        <ul className={css.suggestions}>
          {suggestions.map((suggestion, index) => (
            <li
              onClick={() => suggestionHandler?.(suggestion)}
              key={suggestion.name}
              className={selectedSuggestionIndex === index ? css.active : ''}
            >
              <div className={css.left}>
                {!!suggestion.icon && (
                  <ImageComponent
                    src={suggestion.icon}
                    objectFit="cover"
                    alt={suggestion.name}
                    width={50}
                    height={50}
                  />
                )}
              </div>
              <div>{suggestion.name}</div>
            </li>
          ))}
        </ul>
      )}
    </div>
  )
)

export default Search
Search.displayName = 'Search'
